var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstructionHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 36,
    viewBox: "0 0 48 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 21C45 13.4766 40.38 7.03875 33.8259 4.34812L30 12V1.5C30 1.10218 29.842 0.720645 29.5607 0.43934C29.2794 0.158036 28.8978 0 28.5 0H19.5C19.1022 0 18.7206 0.158036 18.4393 0.43934C18.158 0.720645 18 1.10218 18 1.5V12L14.1741 4.34812C7.62 7.03875 3 13.4766 3 21V27H45V21ZM46.5 30H1.5C1.10218 30 0.720644 30.158 0.43934 30.4393C0.158035 30.7206 0 31.1022 0 31.5L0 34.5C0 34.8978 0.158035 35.2794 0.43934 35.5607C0.720644 35.842 1.10218 36 1.5 36H46.5C46.8978 36 47.2794 35.842 47.5607 35.5607C47.842 35.2794 48 34.8978 48 34.5V31.5C48 31.1022 47.842 30.7206 47.5607 30.4393C47.2794 30.158 46.8978 30 46.5 30Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructionHat);
export default __webpack_public_path__ + "static/media/construction-hat.dc380f9e3846f131a98e391a57f8ef39.svg";
export { ForwardRef as ReactComponent };